import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Shield, Heart, Briefcase, Globe, Activity, FileText, ArrowRight, Fuel, BarChart3, Truck } from "lucide-react";
import { Reveal, RevealStagger } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { Link } from "react-router-dom";

const ICON_MAP = { Shield, Heart, Briefcase, Globe, Activity, FileText, Fuel, BarChart3, Truck };

export default function PracticeAreas() {
  const { t } = useLanguage();
  const pa = t("practiceAreas");
  const items = pa.items || [];

  return (
    <section id="practice-areas" data-testid="practice-areas-section" aria-label="Servicios especializados de regulación energética" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="mb-16">
          <p className="text-[#B59A65] text-xs uppercase tracking-[0.3em] mb-3 font-semibold">{pa.subtitle}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#152238] mb-4 tracking-[-0.02em]">{pa.headline}</h2>
          <p className="text-[#66727B] max-w-lg text-base">{pa.description}</p>
        </Reveal>

        <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="practice-areas-grid">
          {items.map((area) => {
            const Icon = ICON_MAP[area.icon];
            return (
              <Link key={area.id} to={`/services/${area.id}`}>
                <Card
                  data-testid={`practice-area-card-${area.id}`}
                  className="reveal-child bg-[#faf8f4] rounded-2xl border-0 shadow-none hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group p-0 h-full"
                >
                  <CardHeader className="pb-2 pt-8 px-8">
                    <div className="w-12 h-12 rounded-xl bg-[#152238] flex items-center justify-center mb-5 group-hover:bg-[#103F38] transition-colors duration-300">
                      {Icon && <Icon className="h-5 w-5 text-white" />}
                    </div>
                    <h3 className="font-heading text-xl font-bold text-[#152238]">{area.title}</h3>
                  </CardHeader>
                  <CardContent className="px-8 pb-8">
                    <p className="text-[#66727B] text-sm leading-relaxed mb-5">{area.shortDesc}</p>
                    <span className="text-[#103F38] text-sm font-semibold inline-flex items-center gap-2 group-hover:gap-3 transition-all">
                      {pa.learnMore}
                      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </span>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </RevealStagger>
      </div>
    </section>
  );
}
